/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseAppearanceProperties } from './DatabaseAppearanceProperties';
import {
    DatabaseAppearancePropertiesFromJSON,
    DatabaseAppearancePropertiesFromJSONTyped,
    DatabaseAppearancePropertiesToJSON,
} from './DatabaseAppearanceProperties';
import type { DatabaseAudioSettings } from './DatabaseAudioSettings';
import {
    DatabaseAudioSettingsFromJSON,
    DatabaseAudioSettingsFromJSONTyped,
    DatabaseAudioSettingsToJSON,
} from './DatabaseAudioSettings';
import type { DatabaseBackgroundImageSettings } from './DatabaseBackgroundImageSettings';
import {
    DatabaseBackgroundImageSettingsFromJSON,
    DatabaseBackgroundImageSettingsFromJSONTyped,
    DatabaseBackgroundImageSettingsToJSON,
} from './DatabaseBackgroundImageSettings';
import type { DatabaseEntryFileMetaData } from './DatabaseEntryFileMetaData';
import {
    DatabaseEntryFileMetaDataFromJSON,
    DatabaseEntryFileMetaDataFromJSONTyped,
    DatabaseEntryFileMetaDataToJSON,
} from './DatabaseEntryFileMetaData';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFlyerToolbarSettings } from './DatabaseFlyerToolbarSettings';
import {
    DatabaseFlyerToolbarSettingsFromJSON,
    DatabaseFlyerToolbarSettingsFromJSONTyped,
    DatabaseFlyerToolbarSettingsToJSON,
} from './DatabaseFlyerToolbarSettings';
import type { DatabaseMediaStartMode } from './DatabaseMediaStartMode';
import {
    DatabaseMediaStartModeFromJSON,
    DatabaseMediaStartModeFromJSONTyped,
    DatabaseMediaStartModeToJSON,
} from './DatabaseMediaStartMode';
import type { DatabasePageTransitionName } from './DatabasePageTransitionName';
import {
    DatabasePageTransitionNameFromJSON,
    DatabasePageTransitionNameFromJSONTyped,
    DatabasePageTransitionNameToJSON,
} from './DatabasePageTransitionName';
import type { DatabasePages } from './DatabasePages';
import {
    DatabasePagesFromJSON,
    DatabasePagesFromJSONTyped,
    DatabasePagesToJSON,
} from './DatabasePages';
import type { DatabaseSettings } from './DatabaseSettings';
import {
    DatabaseSettingsFromJSON,
    DatabaseSettingsFromJSONTyped,
    DatabaseSettingsToJSON,
} from './DatabaseSettings';

/**
 * 
 * @export
 * @interface DatabaseTemplate
 */
export interface DatabaseTemplate {
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplate
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplate
     */
    parent?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    allowStaticContentModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    considerCustomerFinePrints?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseTemplate
     */
    organisationIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplate
     */
    templateCanonicalId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    purchasable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplate
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplate
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplate
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseTemplate
     */
    readonly created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseTemplate
     */
    readonly updated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    hasCommentBtn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    hasLikeBtn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    hideFieldTitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    hideDetailsForAnonymous?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    sendMailOnNewEntry?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    sendMailOnNewComment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    ownSmtpSettings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTemplate
     */
    readonly hasChildren?: boolean;
    /**
     * 
     * @type {Array<DatabaseField>}
     * @memberof DatabaseTemplate
     */
    readonly fields?: Array<DatabaseField>;
    /**
     * 
     * @type {Array<DatabaseEntryFileMetaData>}
     * @memberof DatabaseTemplate
     */
    readonly attachments?: Array<DatabaseEntryFileMetaData>;
    /**
     * 
     * @type {DatabaseAppearanceProperties}
     * @memberof DatabaseTemplate
     */
    appearance?: DatabaseAppearanceProperties;
    /**
     * 
     * @type {DatabaseSettings}
     * @memberof DatabaseTemplate
     */
    settings?: DatabaseSettings;
    /**
     * 
     * @type {DatabasePages}
     * @memberof DatabaseTemplate
     */
    additionalPages?: DatabasePages;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseTemplate
     */
    readonly contentPages?: Array<string>;
    /**
     * 
     * @type {DatabasePageTransitionName}
     * @memberof DatabaseTemplate
     */
    pageTransition?: DatabasePageTransitionName;
    /**
     * 
     * @type {DatabaseMediaStartMode}
     * @memberof DatabaseTemplate
     */
    mediaStartMode?: DatabaseMediaStartMode;
    /**
     * 
     * @type {DatabaseAudioSettings}
     * @memberof DatabaseTemplate
     */
    audio?: DatabaseAudioSettings;
    /**
     * 
     * @type {DatabaseBackgroundImageSettings}
     * @memberof DatabaseTemplate
     */
    backgroundImage?: DatabaseBackgroundImageSettings;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplate
     */
    imageRef?: string;
    /**
     * 
     * @type {DatabaseFlyerToolbarSettings}
     * @memberof DatabaseTemplate
     */
    flyerToolbar?: DatabaseFlyerToolbarSettings;
}

/**
 * Check if a given object implements the DatabaseTemplate interface.
 */
export function instanceOfDatabaseTemplate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTemplateFromJSON(json: any): DatabaseTemplate {
    return DatabaseTemplateFromJSONTyped(json, false);
}

export function DatabaseTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'allowStaticContentModification': !exists(json, 'allowStaticContentModification') ? undefined : json['allowStaticContentModification'],
        'considerCustomerFinePrints': !exists(json, 'considerCustomerFinePrints') ? undefined : json['considerCustomerFinePrints'],
        'organisationIds': !exists(json, 'organisationIds') ? undefined : json['organisationIds'],
        'templateCanonicalId': !exists(json, 'templateCanonicalId') ? undefined : json['templateCanonicalId'],
        'purchasable': !exists(json, 'purchasable') ? undefined : json['purchasable'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'hasCommentBtn': !exists(json, 'hasCommentBtn') ? undefined : json['hasCommentBtn'],
        'hasLikeBtn': !exists(json, 'hasLikeBtn') ? undefined : json['hasLikeBtn'],
        'hideFieldTitles': !exists(json, 'hideFieldTitles') ? undefined : json['hideFieldTitles'],
        'hideDetailsForAnonymous': !exists(json, 'hideDetailsForAnonymous') ? undefined : json['hideDetailsForAnonymous'],
        'sendMailOnNewEntry': !exists(json, 'sendMailOnNewEntry') ? undefined : json['sendMailOnNewEntry'],
        'sendMailOnNewComment': !exists(json, 'sendMailOnNewComment') ? undefined : json['sendMailOnNewComment'],
        'ownSmtpSettings': !exists(json, 'ownSmtpSettings') ? undefined : json['ownSmtpSettings'],
        'hasChildren': !exists(json, 'hasChildren') ? undefined : json['hasChildren'],
        'fields': !exists(json, 'fields') ? undefined : ((json['fields'] as Array<any>).map(DatabaseFieldFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(DatabaseEntryFileMetaDataFromJSON)),
        'appearance': !exists(json, 'appearance') ? undefined : DatabaseAppearancePropertiesFromJSON(json['appearance']),
        'settings': !exists(json, 'settings') ? undefined : DatabaseSettingsFromJSON(json['settings']),
        'additionalPages': !exists(json, 'additionalPages') ? undefined : DatabasePagesFromJSON(json['additionalPages']),
        'contentPages': !exists(json, 'contentPages') ? undefined : json['contentPages'],
        'pageTransition': !exists(json, 'pageTransition') ? undefined : DatabasePageTransitionNameFromJSON(json['pageTransition']),
        'mediaStartMode': !exists(json, 'mediaStartMode') ? undefined : DatabaseMediaStartModeFromJSON(json['mediaStartMode']),
        'audio': !exists(json, 'audio') ? undefined : DatabaseAudioSettingsFromJSON(json['audio']),
        'backgroundImage': !exists(json, 'backgroundImage') ? undefined : DatabaseBackgroundImageSettingsFromJSON(json['backgroundImage']),
        'imageRef': !exists(json, 'imageRef') ? undefined : json['imageRef'],
        'flyerToolbar': !exists(json, 'flyerToolbar') ? undefined : DatabaseFlyerToolbarSettingsFromJSON(json['flyerToolbar']),
    };
}

export function DatabaseTemplateToJSON(value?: DatabaseTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryId': value.categoryId,
        'parent': value.parent,
        'allowStaticContentModification': value.allowStaticContentModification,
        'considerCustomerFinePrints': value.considerCustomerFinePrints,
        'organisationIds': value.organisationIds,
        'templateCanonicalId': value.templateCanonicalId,
        'purchasable': value.purchasable,
        'name': value.name,
        'title': value.title,
        'description': value.description,
        'hasCommentBtn': value.hasCommentBtn,
        'hasLikeBtn': value.hasLikeBtn,
        'hideFieldTitles': value.hideFieldTitles,
        'hideDetailsForAnonymous': value.hideDetailsForAnonymous,
        'sendMailOnNewEntry': value.sendMailOnNewEntry,
        'sendMailOnNewComment': value.sendMailOnNewComment,
        'ownSmtpSettings': value.ownSmtpSettings,
        'appearance': DatabaseAppearancePropertiesToJSON(value.appearance),
        'settings': DatabaseSettingsToJSON(value.settings),
        'additionalPages': DatabasePagesToJSON(value.additionalPages),
        'pageTransition': DatabasePageTransitionNameToJSON(value.pageTransition),
        'mediaStartMode': DatabaseMediaStartModeToJSON(value.mediaStartMode),
        'audio': DatabaseAudioSettingsToJSON(value.audio),
        'backgroundImage': DatabaseBackgroundImageSettingsToJSON(value.backgroundImage),
        'imageRef': value.imageRef,
        'flyerToolbar': DatabaseFlyerToolbarSettingsToJSON(value.flyerToolbar),
    };
}

